var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.pantanir = {
	init: function() {
		$('#pantanirToggle').click(function(e) {
			var pantanirOpen = $('body').hasClass('pantanir-open');
			site.pantanir.pantanirToggle(e, pantanirOpen);
			e.stopPropagation();

			$('body').on('click', function(e) {
				e.stopPropagation();
			});

			e.preventDefault();
		});
		$('#pantauth input').bind('keypress', function(e) {
			var code = (e.keyCode ? e.keyCode : e.which);
			if(code == 13) { //Enter keycode
				e.preventDefault();
				$('#pantauthsubmit').trigger('click');
			}
		});
	},
	// Toggle pantanir form
	pantanirToggle: function(e, menuOpen) {
		$('body').toggleClass('pantanir-open');
		$(this).toggleClass('open');
	},
};

site.frontpage = {
	init: function() {
		if($('#hero li').length > 1) {
			site.owl.init('#hero > ul'), {
				loop: true,
				dots:true,
				nav: false,
				items:1,
				navText: ["",""],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn'
			}
		}
	}
};

site.extras = {
	itemFormFilters: function() {
		$('#fieldset-buttons .dgElements .btn').each(function() {
			$(this).on('click', function(e) {
				e.preventDefault();
				$(this).toggleClass('selected');
				if ($(this).hasClass('all')) {
					site.extras.toggleFormFilters($(this).hasClass('selected'), true);
				} else {
					var classes = $(this).attr('class');
					var elmClass = '.' + classes.match(/elm_ExtraDesc\d+/gi)[0];
					console.log(elmClass);
					if($('#fieldset-buttons .dgElements .all').hasClass('selected')) {
						$('#fieldset-buttons .dgElements .all').removeClass('selected');
						site.extras.toggleFormFilters(false, false);
						$('.moya_form').children(elmClass).removeClass('hide');
					}
					else {
						$('.moya_form').children(elmClass).toggleClass('hide');
						$('.moya_form').children(elmClass).children('textarea').toggleClass('hide');
					}

				}
			});
		});
	},
	toggleFormFilters: function(toggle, all) {
		$('.moya_form > .extraDesc').each(function() {
			if (toggle) {
				$(this).removeClass('hide');
				$(this).find('*').removeClass('hide');
			} else {
				$(this).addClass('hide');
			}
			if(all) {
				$('#fieldset-buttons .dgElements .btn:not(.all)').each(function() {
					$(this).removeClass('selected');
				});
			}
		})
	}
};

site.askrift = {
	init: function(form) {
		var errorName = 'Þú verður að gefa upp nafn nemanda/notanda kortsins';
		var errorKt = 'Þú verður að gefa upp kennitölu nemanda/notanda kortsins';

		var form = $(form);
		var div = form.prev('.nemandi');
		var item = form.find('input[name="item1_desc"]');
		var user1 = form.find('input[name="user1"]');
		var rebill = form.find('input[name="rebill_desc"]');

		var name = site.askrift.utf8_encode(div.find('input[name="name"]').val());
		var kt = div.find('input[name="kt"]').val();

		if (name.length < 1) {
			alert(errorName);
			return false;
		}
		if (kt.length < 10) {
			alert(errorKt);
			return false;
		}

		item.val(item.val().replace('%REPLACE%', name));
		user1.val(kt);

		if (rebill.length > 0) {
			rebill.val(rebill.val().replace('%REPLACE%', name));
		}
	},
	utf8_encode: function(argString) {
		// http://kevin.vanzonneveld.net
		// +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
		// +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
		// +   improved by: sowberry
		// +    tweaked by: Jack
		// +   bugfixed by: Onno Marsman
		// +   improved by: Yves Sucaet
		// +   bugfixed by: Onno Marsman
		// +   bugfixed by: Ulrich
		// +   bugfixed by: Rafal Kukawski
		// +   improved by: kirilloid
		// *     example 1: utf8_encode('Kevin van Zonneveld');
		// *     returns 1: 'Kevin van Zonneveld'

		if (argString === null || typeof argString === "undefined") {
			return "";
		}

		var string = (argString + ''); // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
		var utftext = '',
			start, end, stringl = 0;

		start = end = 0;
		stringl = string.length;
		for (var n = 0; n < stringl; n++) {
			var c1 = string.charCodeAt(n);
			var enc = null;

			if (c1 < 128) {
				end++;
			} else if (c1 > 127 && c1 < 2048) {
				enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
			} else {
				enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
			}
			if (enc !== null) {
				if (end > start) {
					utftext += string.slice(start, end);
				}
				utftext += enc;
				start = end = n + 1;
			}
		}

		if (end > start) {
			utftext += string.slice(start, stringl);
		}

		return utftext;
	}
};

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('input#class.hidden').length > 0;
			}, function () {
				$('input#class.hidden').removeClass('hidden').addClass('text').attr('type', 'text').wrap('<dd id="class-element" />').wrap('<span class="lmnt" />').closest('dd').prepend('<dt id="class-label"><label for="class" class="optional">Auka klasar</label></dt>');
			}, function () {

			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.pantanir.init();
	//site.askrift.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}
	if ($('body').is('.frontpage')) {
		//site.frontpage.init();
	}
	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
